import React from "react";
import "./Section1.css";

function Section1() {
  return (
    <div className="section1">
      <div className="part1">
        <h3>Back in stock!</h3>
        <h1>OUR BEST SWIM</h1>
      </div>
    </div>
  );
}

export default Section1;
